import { render } from "./Media.vue?vue&type=template&id=48af3b42&scoped=true&ts=true"
import script from "./Media.vue?vue&type=script&lang=ts"
export * from "./Media.vue?vue&type=script&lang=ts"

import "./Media.vue?vue&type=style&index=0&id=48af3b42&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48af3b42"]])

export default __exports__